import {FC, useEffect, useRef} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {useAppSelector} from '../../../../setup/redux/hooks'
import {
  branchUsersFilterDataChange,
  getBranchUsers,
  selectBranchUsersFilter,
  selectBranchUsersList,
  updateUserBranchStatus,
} from '../redux/BranchRedux'
import {PaginateModel} from '../../../shared/models/PaginateModel'
import Paginator from '../../../components/Paginator'
import moment from 'moment'

import Tooltip from 'react-tooltip-lite'
import {UserBranchModel} from '../models/UserBranchModel'
import {USER_STATUS} from '../../../shared/constants'

type Props = {
  className?: string
}

const UserBranchTable: FC<Props> = (props) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const didRequest = useRef(false)
  const data: UserBranchModel[] = useAppSelector(selectBranchUsersList)
  const filter: PaginateModel = useAppSelector(selectBranchUsersFilter)

  useEffect(() => {
    if (!didRequest.current) {
      dispatch(getBranchUsers())
      didRequest.current = true
    }
  }, [])

  const handlePageChanged = (targetPage: number) => {
    dispatch(branchUsersFilterDataChange({...filter, page: targetPage}))
  }

  const renderItemActions = (user: UserBranchModel) => {
    let actions = []

    if (user.status === USER_STATUS.ACTIVE) {
      actions = [
        <Tooltip
          content={<div>{intl.formatMessage({id: 'Scheduler.STATUS.INACTIVE'})}</div>}
          className='tooltips'
        >
          <button
            key='status'
            className='btn btn-icon btn-light-danger btn-sm'
            onClick={() => {
              dispatch(updateUserBranchStatus({userIds: [user.id], status: USER_STATUS.INACTIVE}))
            }}
          >
            <i className='bi bi-x-circle fs-4'></i>
          </button>
        </Tooltip>,
      ]
    } else {
      actions = [
        <Tooltip
          content={<div>{intl.formatMessage({id: 'Scheduler.STATUS.ACTIVE'})}</div>}
          className='tooltips'
        >
          <button
            key='status'
            className='btn btn-icon btn-light-success btn-sm'
            onClick={() => {
              dispatch(updateUserBranchStatus({userIds: [user.id], status: USER_STATUS.ACTIVE}))
            }}
          >
            <i className='bi bi-check-circle fs-4'></i>
          </button>
        </Tooltip>,
      ]
    }

    return <div className='d-flex justify-content-end flex-shrink-0'>{actions}</div>
  }

  const renderBrandUserItem = (user: UserBranchModel) => {
    return (
      <tr key={user.id}>
        <td> {user.id.toString()}</td>
        <td> {user.firstName} </td>
        <td> {user.lastName} </td>
        <td> {user.email} </td>
        <td> {user.branchName} </td>
        <td> {user.totalOrders} </td>
        <td>
          <span
            className={`badge badge-light-${
              user.status === USER_STATUS.ACTIVE ? 'success' : 'danger'
            } d-inline-flex align-items-center`}
          >
            {intl.formatMessage({id: 'BRANCH.STATUS.' + user.status})}
          </span>
        </td>
        <td> {moment(user.createdAt).format(process.env.REACT_APP_DATE_FORMAT)} </td>
        <td>{renderItemActions(user)}</td>
      </tr>
    )
  }
  return (
    <>
      <div className='table-responsive'>
        {/* begin::Table */}
        <table className='table table-hover table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
          {/* begin::Table head */}
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              <th>{intl.formatMessage({id: 'BRANCH.USER.TABLE.ID'})}</th>
              <th>{intl.formatMessage({id: 'BRANCH.USER.TABLE.FIRST_NAME'})}</th>
              <th>{intl.formatMessage({id: 'BRANCH.USER.TABLE.LAST_NAME'})}</th>
              <th>{intl.formatMessage({id: 'BRANCH.USER.TABLE.EMAIL'})}</th>
              <th>{intl.formatMessage({id: 'BRANCH.USER.TABLE.BRAND_NAME'})}</th>
              <th>{intl.formatMessage({id: 'BRANCH.USER.TABLE.TOTAL_ORDERS'})}</th>
              <th>{intl.formatMessage({id: 'BRANCH.USER.TABLE.STATUS'})}</th>
              <th>{intl.formatMessage({id: 'BRANCH.USER.TABLE.CREATE_AT'})}</th>
              <th className='text-end'>{intl.formatMessage({id: 'BRANCH.USER.TABLE.ACTION'})}</th>
            </tr>
          </thead>
          {/* end::Table head */}
          {/* begin::Table body */}
          <tbody>{data?.map((item: any) => renderBrandUserItem(item))}</tbody>
          {/* end::Table body */}
        </table>
        {/* end::Table */}
      </div>
      <div className='d-flex justify-content-end pt-10'>
        <Paginator
          currentPage={filter.page}
          totalPages={filter.pageCount || 1}
          onPageChange={handlePageChanged}
        />
      </div>
    </>
  )
}

export default UserBranchTable
